import { useEffect } from 'react';
import { Modal, Dropdown } from 'antd'
import Cookie from 'js-cookie';
import { ACCESS_TOKEN_KEY, USER_ID_KEY, APP_ID } from '../../constants'
import { UserOutlined } from '@ant-design/icons';
import { useApp } from '../../model';
import { getUser, logout } from '../../api/user';
import { useNavigate } from 'react-router-dom';

export const logoutMe = () => {
    logout({
        accessToken: Cookie.get(ACCESS_TOKEN_KEY) as string,
        applicationId: APP_ID + '',
    });
    Cookie.remove(ACCESS_TOKEN_KEY);
    Cookie.remove(USER_ID_KEY);
    window.location.href = '/login?href=' + window.location.href;
}

export default function UserMenu() {
    const { pathname } = window.location
    const { currentUserId, currentUser, setState } = useApp();
    const navigate = useNavigate()
    useEffect(() => {
        if (currentUserId) {
            getUser(currentUserId)
                .then((data) => {
                    setState('currentUser', data)
                })
        }
    }, [currentUserId, pathname]);
    const user = currentUser as UserRecord | null;

    return (
        <>
            <Dropdown menu={{
                items: [
                    {
                        label: '退出登录', key: '1',
                        onClick() {
                            Modal.confirm({
                                title: '确定退出登录?',
                                onOk() {
                                    logoutMe()
                                }
                            })
                        }
                    },
                ]
            }}>
                <div onClick={() => {
                    navigate('/me')
                }} style={{ cursor: 'pointer', color: 'white', display: 'flex', alignItems: 'center' }}>
                    <UserOutlined style={{ fontSize: 18, marginRight: 10 }} /> {user?.name}
                </div>
            </Dropdown>
        </>
    )
}